(function () {
  var root = document.querySelector('.lbd-configurator');
  if (!root) return;

  var canvas = root.querySelector('[data-lbd-render]');
  var acrylicSelect = root.querySelector('[data-lbd-acrylic]');
  var metalSelect = root.querySelector('[data-lbd-metal]');
  if (!canvas || !acrylicSelect || !metalSelect) return;

  var imageSets = window.LBD_BEAUBOURG_STRUCTURE_IMAGES || {};
  var swatchImages = window.LBD_BEAUBOURG_SWATCHES || {};
  var generatedTemplate = window.LBD_BEAUBOURG_GENERATED_TEMPLATE || '';
  var chairTemplate = window.LBD_CHAIR_VALIDATED_TEMPLATE || '';
  var handle = canvas.dataset.handle;
  var isBeaubourg = handle === 'tabouret-beaubourg-personnalisation';
  var isChair = handle === 'chaise-personnalisation';
  var applyTimer = 0;
  var observerPaused = false;
  var imageRequestSerial = 0;

  function applyValidatedSwatches() {
    var order = ['INC', 'GIV', 'FUM', 'JAU', 'ROU', 'BLE', 'ORA', 'ROS', 'VIO', 'VER', 'NOI', 'BEI', 'KAK', 'MAR', 'BLA'];
    var wrapper = root.querySelector('[data-lbd-acrylic-swatches]');
    if (!wrapper) return;
    var buttons = Array.prototype.slice.call(wrapper.querySelectorAll('.lbd-configurator__swatch'));
    var byCode = {};
    Array.prototype.forEach.call(acrylicSelect.options, function (option, index) {
      var code = option.dataset.code;
      var button = buttons[index];
      var imageUrl = swatchImages[code];
      if (!code || !button || !imageUrl) return;
      button.style.setProperty('--lbd-swatch-image', 'url("' + imageUrl + '")');
      button.classList.add('is-validated-image');
      button.dataset.calibration = code + '-validated-image';
      byCode[code] = button;
    });
    order.forEach(function (code) {
      if (byCode[code]) wrapper.appendChild(byCode[code]);
    });
  }

  applyValidatedSwatches();
  if (!isBeaubourg && !isChair) {
    var swatchStyle = document.createElement('style');
    swatchStyle.textContent =
      '.lbd-configurator__swatch--acrylic.is-validated-image:before{' +
      'background-image:var(--lbd-swatch-image)!important;' +
      'background-position:center!important;background-size:cover!important;' +
      'background-repeat:no-repeat!important;' +
      'box-shadow:inset 0 0 0 1px rgba(17,17,17,.18),0 0 0 1px rgba(255,255,255,.92)!important}' +
      '.lbd-configurator__swatch--acrylic.is-validated-image:after{display:none!important}';
    document.head.appendChild(swatchStyle);
    return;
  }

  /* Le canevas historique est remplacé : il ne peut plus fabriquer ni afficher un rendu. */
  var staticImage = document.createElement('img');
  staticImage.className = canvas.className;
  staticImage.alt = isChair ? 'Chaise personnalisable - visuel validé' : 'Tabouret Beaubourg - visuel validé';
  staticImage.width = canvas.width;
  staticImage.height = canvas.height;
  staticImage.dataset.lbdStaticImage = 'true';
  staticImage.decoding = 'async';
  canvas.replaceWith(staticImage);

  function selectedCode() {
    var option = acrylicSelect.options[acrylicSelect.selectedIndex];
    return option ? option.dataset.code : '';
  }

  function selectedRal() {
    var option = metalSelect.options[metalSelect.selectedIndex];
    return option ? option.dataset.ral : '';
  }

  function selectedImage() {
    if (isChair) {
      if (!chairTemplate) return '';
      var chairUrl = chairTemplate.replace(
        /172MA004-[0-9]{4}-[A-Z]{3}\.webp/,
        '172MA004-' + selectedRal() + '-' + selectedCode() + '.webp'
      );
      return chairUrl + (chairUrl.indexOf('?') === -1 ? '?' : '&') + 'lbd=chair-fixed-mask-v2';
    }
    var set = imageSets[selectedRal()] || {};
    var officialImage = set[selectedCode()] || '';
    if (officialImage) return officialImage;
    if (!generatedTemplate) return '';
    return generatedTemplate.replace(
      /172MA055-[0-9]{4}-[A-Z]{3}\.webp/,
      '172MA055-' + selectedRal() + '-' + selectedCode() + '.webp'
    );
  }

  function previewProperty() {
    var form = root.querySelector('#lbd-configurator-form');
    if (!form) return null;
    var input = form.querySelector('[data-lbd-preview-url]');
    if (input) return input;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[_Aperçu configuré]';
    input.dataset.lbdPreviewUrl = 'true';
    form.appendChild(input);
    return input;
  }

  function productImages() {
    var candidates = Array.prototype.slice.call(document.querySelectorAll(
      'img[alt*="Tabouret Beaubourg"],img[alt*="Tabouret personnalisable"],img[alt*="Chaise"]'
    ));
    if (candidates.indexOf(staticImage) === -1) candidates.push(staticImage);
    return candidates;
  }

  function sameAsset(current, expected) {
    if (!current || !expected) return false;
    var expectedName = expected.split('?')[0].split('/').pop();
    return current.indexOf(expectedName) !== -1;
  }

  function setStaticSource(image, imageUrl) {
    if (sameAsset(image.currentSrc || image.src, imageUrl)) return;
    observerPaused = true;
    image.src = imageUrl;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    var picture = image.closest('picture');
    if (picture) {
      Array.prototype.forEach.call(picture.querySelectorAll('source'), function (source) {
        source.removeAttribute('srcset');
        source.removeAttribute('sizes');
      });
    }
    requestAnimationFrame(function () { observerPaused = false; });
  }

  function applyStaticImage() {
    var imageUrl = selectedImage();
    if (!imageUrl) {
      root.dataset.visualPending = selectedRal() + '-' + selectedCode();
      return;
    }

    var requestSerial = ++imageRequestSerial;
    var expectedCode = selectedCode();
    var expectedRal = selectedRal();
    var images = productImages();
    images.forEach(function (image) {
      image.style.opacity = '0';
      image.setAttribute('aria-busy', 'true');
    });
    root.dataset.visualLoading = expectedRal + '-' + expectedCode;

    var preload = new Image();
    preload.onload = function () {
      if (requestSerial !== imageRequestSerial) return;
      delete root.dataset.visualPending;
      delete root.dataset.visualLoading;
      var property = previewProperty();
      if (property) property.value = imageUrl;
      images.forEach(function (image) {
        setStaticSource(image, imageUrl);
        image.style.opacity = '';
        image.removeAttribute('aria-busy');
      });
      root.dataset.materialEngine = isChair ? 'validated-chair-files-v2' : 'validated-files-only-v2';
      root.dataset.acrylicCode = expectedCode;
      root.dataset.structureRal = expectedRal;
    };
    preload.onerror = function () {
      if (requestSerial !== imageRequestSerial) return;
      delete root.dataset.visualLoading;
      root.dataset.visualError = expectedRal + '-' + expectedCode;
    };
    preload.src = imageUrl;
  }

  function scheduleStaticImage() {
    clearTimeout(applyTimer);
    applyStaticImage();
    applyTimer = setTimeout(applyStaticImage, 80);
  }

  function syncSwatches() {
    var buttons = root.querySelectorAll('[data-lbd-acrylic-swatches] .lbd-configurator__swatch');
    Array.prototype.forEach.call(acrylicSelect.options, function (option, index) {
      var code = option.dataset.code;
      var imageUrl = swatchImages[code];
      var button = Array.prototype.find.call(buttons, function (candidate) {
        return candidate.dataset.index === String(index);
      });
      if (!imageUrl || !button) return;
      button.style.setProperty('--lbd-swatch-image', 'url("' + imageUrl + '")');
      button.classList.add('is-validated-image');
      button.dataset.calibration = code + '-validated-image';
    });
  }

  function syncCurrentPreview() {
    var imageUrl = swatchImages[selectedCode()];
    if (!imageUrl) return;
    var background = 'url("' + imageUrl + '") center/cover no-repeat';
    var sample = root.querySelector('.lbd-configurator__sample--acrylic');
    var preview = root.querySelector('.lbd-configurator__acrylic-preview');
    [sample, preview].forEach(function (element) {
      if (!element) return;
      element.style.background = background;
    });
  }

  function update() {
    syncSwatches();
    syncCurrentPreview();
    scheduleStaticImage();
  }

  var style = document.createElement('style');
  style.textContent =
    '.lbd-configurator__swatch--acrylic.is-validated-image:before{' +
    'background-image:var(--lbd-swatch-image)!important;' +
    'background-position:center!important;background-size:cover!important;' +
    'background-repeat:no-repeat!important;' +
    'box-shadow:inset 0 0 0 1px rgba(17,17,17,.18),0 0 0 1px rgba(255,255,255,.92)!important}' +
    '.lbd-configurator__swatch--acrylic.is-validated-image:after{display:none!important}';
  document.head.appendChild(style);

  var observer = new MutationObserver(function (mutations) {
    if (observerPaused) return;
    var imageUrl = selectedImage();
    if (!imageUrl) return;
    var overwritten = mutations.some(function (mutation) {
      var target = mutation.target;
      return target instanceof HTMLImageElement &&
        productImages().indexOf(target) !== -1 &&
        !sameAsset(target.currentSrc || target.src, imageUrl);
    });
    if (overwritten) scheduleStaticImage();
  });
  observer.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset']
  });

  acrylicSelect.addEventListener('change', update);
  metalSelect.addEventListener('change', update);
  window.addEventListener('load', scheduleStaticImage);
  update();
})();
